var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-candidate"}},[_c('div',{staticClass:"container has-nav-top-margin"},[_c('profile-candidate',{attrs:{"profile":_vm.user.profile,"account":_vm.user.account},on:{"refreshProfile":_vm.refreshProfile}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }